import React, { useReducer, useContext, useEffect, useMemo } from 'react';
import DefaultModal from '../Utils/DefaultModal';
import { Box, TextField } from '@mui/material';
import { externalComponent } from '../AppRoutes';
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import Table, { TableHook } from '../Table';
import ColorButton from '../Buttons/ColorButton';


export const tipo = {
    1: 3, //V10
    2: 0 //BKS
}

const getcolumns = () => {
    const columns = []
    columns.push({ field: 'Cod', headerName: 'Código', width: 100 })
    columns.push({ field: 'Descricao', headerName: 'Descrição', width: 300 })
    return columns
}

const getProdutos = async (setLoader, setState, productsRow, obj) => {
    setLoader(true)
    const res = await api.post(`/tabelas/produtos/`)
    setLoader(false)
    if (res.status === 200) {
        const data = res.data.filter(item => !productsRow.some(existingItem => existingItem.Cod === item.Cod))
            .map(each => ({ ...each, id: each.Cod, preco: 0, preco_minimo: 0, comissao: tipo[obj.id_tipo], checked: false, promocao: false }));

        const lista = data.sort((a, b) => {
            if (a.Descricao < b.Descricao) return -1;
            if (a.Descricao > b.Descricao) return 1;
            return 0;
        });
        setState({ rows: lista, resetRows: lista })
    }
}

const filterCod = (value, state, setState) => {
    if (value === '') {
        setState({ searchCod: value, rows: state.resetRows })
    } else {
        const rows = state.resetRows.filter(row =>
            row.Cod.toString() === value
        );
        setState({ searchCod: value, rows: rows })
    }
}

const filterDescricao = (value, state, setState) => {
    if (value === '') {
        setState({ searchDescricao: value, rows: state.resetRows })
    } else {
        const rows = state.resetRows.filter(row =>
            row.Descricao.toLowerCase().includes(value.toLowerCase())
        );
        setState({ searchDescricao: value, rows: rows })
    }
}

const submit = (state, handleClose, setProducts, productsRow, table) => {
    const selectedIDs = table.apiRef.current.getSelectedRows();
    const newArray = Array.from(selectedIDs.keys())
    const products = state.rows.filter(each => newArray.includes(each.Cod));
    const data = [...productsRow, ...products]
    const lista = data.sort((a, b) => {
        if (a.Descricao < b.Descricao) return -1;
        if (a.Descricao > b.Descricao) return 1;
        return 0;
    });
    setProducts({ rows: lista })
    handleClose()
}


const ModalProdutos = ({ handleClose, setProducts, productsRow, data }) => {

    const [state, setState] = useReducer(lockedReducer, {
        productModal: null,
        rows: [],
        resetRows: [],
        searchCod: '',
        searchDescricao: ''
    })

    const { setLoader } = useContext(externalComponent)

    const [table] = TableHook()

    useEffect(() => {
        getProdutos(setLoader, setState, productsRow, data)
    }, [])

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: "xl" }}
                handleClose={handleClose}
                open={true}
                title={`Inclusão de produtos`}
                content={


                    <Box sx={{ width: '100%', height: '23.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                            <TextField
                                id="searchCod"
                                type="text"
                                label="Código"
                                size='small'
                                value={state.searchCod}
                                onChange={(e) => { filterCod(e.target.value, state, setState) }}
                                onKeyDown={(e) => { filterCod(e.target.value, state, setState) }}
                                fullWidth={false}
                                sx={{ width: '6rem' }}
                            />

                            <TextField
                                id="searchDescricao"
                                type="text"
                                label="Descrição"
                                size='small'
                                value={state.searchDescricao}
                                onChange={(e) => { filterDescricao(e.target.value, state, setState) }}
                                onKeyDown={(e) => { filterDescricao(e.target.value, state, setState) }}
                                fullWidth={false}
                                sx={{ width: '17rem' }}
                            />
                        </Box>

                        <Table
                            paginationMode='client'
                            className='contabil-grid'
                            rows={state.rows}
                            columns={useMemo(() => getcolumns(setState, state), [state.rows, state.edit])}
                            pagination={false}
                            rowHeight={30}
                            checkbox={true}
                            innerRef={table}
                        />
                    </Box>

                }
                action={

                    <ColorButton onClick={() => submit(state, handleClose, setProducts, productsRow, table)}>Salvar</ColorButton>

                }
            />
        </>
    )
}

export default ModalProdutos;